import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#1B5E5E] text-white/60 py-8 text-center text-sm" data-id="element-31">
        <div className="max-w-4xl mx-auto px-6" data-id="element-32">
          <p data-id="element-33">
            © {new Date().getFullYear()} Rodillas Jóvenes. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-34">
            Este producto no sustituye el consejo médico profesional.
          </p>
          <div className="mt-4 flex items-center justify-center gap-4" data-id="element-35">
            <button onClick={() => setActiveModal('privacy')} className="text-white/50 hover:text-[#C9A84C] transition-colors underline underline-offset-2 text-xs cursor-pointer" data-id="element-36">
              Política de Privacidad
            </button>
            <span className="text-white/30" data-id="element-37">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/50 hover:text-[#C9A84C] transition-colors underline underline-offset-2 text-xs cursor-pointer" data-id="element-38">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-39">
          <div className="bg-[#FAF7F2] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-40">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#E8F0EC] bg-white" data-id="element-41">
              <h3 className="text-xl font-bold text-[#1B5E5E] m-0" data-id="element-42">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-[#E8F0EC] transition-colors text-[#1B5E5E] cursor-pointer" aria-label="Cerrar" data-id="element-43">
                <X className="w-5 h-5" data-id="element-44" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-6 py-6 overflow-y-auto text-[#2D2D2D] text-base leading-relaxed space-y-4" data-id="element-45">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-46" /> : <TermsContent data-id="element-47" />}
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 border-t border-[#E8F0EC] bg-white" data-id="element-48">
              <button onClick={() => setActiveModal(null)} className="w-full py-3 bg-[#1B5E5E] text-white rounded-xl font-semibold hover:bg-[#164c4c] transition-colors cursor-pointer" data-id="element-49">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-gray-500" data-id="element-50">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-51">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-52">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital, incluyendo tu nombre, dirección de
        correo electrónico y datos de pago. No almacenamos información de
        tarjetas de crédito en nuestros servidores.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-53">
        2. Uso de la Información
      </h4>
      <p data-id="element-54">
        Tu información personal se utiliza exclusivamente para: procesar y
        entregar tu compra, enviarte el producto digital adquirido, y
        comunicarte actualizaciones importantes relacionadas con tu compra. No
        vendemos, alquilamos ni compartimos tu información personal con terceros
        con fines de marketing.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-55">
        3. Protección de Datos
      </h4>
      <p data-id="element-56">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Todas las transacciones se procesan a
        través de plataformas de pago seguras con encriptación SSL.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-57">4. Cookies</h4>
      <p data-id="element-58">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies, aunque esto podría afectar algunas
        funcionalidades.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-59">5. Tus Derechos</h4>
      <p data-id="element-60">
        Tienes derecho a acceder, corregir o solicitar la eliminación de tu
        información personal en cualquier momento. Para ejercer estos derechos,
        puedes comunicarte con nosotros a través de los canales disponibles en
        nuestro sitio.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-61">
        6. Cambios a Esta Política
      </h4>
      <p data-id="element-62">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-gray-500" data-id="element-63">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-64">1. Producto Digital</h4>
      <p data-id="element-65">
        "Rodillas Jóvenes: El Protocolo de 21 Días" es un producto digital en
        formato PDF. Al completar tu compra, recibirás acceso inmediato para
        descargar el material. Este producto es para uso personal y no puede ser
        redistribuido, revendido ni compartido.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-66">
        2. Descargo de Responsabilidad Médica
      </h4>
      <p data-id="element-67">
        Este producto es únicamente informativo y educativo. No sustituye el
        consejo, diagnóstico o tratamiento médico profesional. Siempre consulta
        con tu médico antes de iniciar cualquier programa de ejercicios o
        cambios en tu rutina de salud. Los resultados pueden variar de persona a
        persona.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-68">
        3. Propiedad Intelectual
      </h4>
      <p data-id="element-69">
        Todo el contenido del eBook, incluyendo textos, imágenes, gráficos y
        diseño, está protegido por derechos de autor. Queda prohibida la
        reproducción, distribución o modificación total o parcial del material
        sin autorización expresa por escrito.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-70">
        4. Política de Reembolso
      </h4>
      <p data-id="element-71">
        Debido a la naturaleza digital del producto, una vez descargado no se
        aceptan devoluciones. Sin embargo, si experimentas problemas técnicos
        con la descarga, nos comprometemos a resolver el inconveniente para que
        puedas acceder a tu material.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-72">
        5. Limitación de Responsabilidad
      </h4>
      <p data-id="element-73">
        No nos hacemos responsables de los resultados individuales obtenidos al
        seguir el protocolo. Los testimonios y ejemplos mencionados no
        garantizan resultados similares. El uso del producto es bajo tu propia
        responsabilidad.
      </p>

      <h4 className="text-lg font-bold text-[#1B5E5E]" data-id="element-74">
        6. Aceptación de Términos
      </h4>
      <p data-id="element-75">
        Al realizar la compra de este producto, confirmas que has leído,
        entendido y aceptado estos términos y condiciones en su totalidad.
      </p>
    </>;
}